import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import Banner from '@cpg-its/ads.containers.banner';
import { ContentSpacer } from '../../../global/components/layout/generic-content-spacer';
import { DemographicsContext } from '../../../global/models/demographics-model';
import { TcsmStates } from '../../../root/tcsm-model';


export enum EnrollmentTypes {
	ANNUAL = 'ANNUAL',
	MIDYEAR = 'MIDYEAR',
}

interface Props {
	type: EnrollmentTypes,
}

export function EnrollmentErrors(props: Props) {
	const app = useContext(DemographicsContext);
	const errors = useSelector<TcsmStates, string[]>(
		state => props.type === EnrollmentTypes.ANNUAL ?
			state.annualEnrollment[app]?.AEInfo?.processing_messages?.errors
			: state.midYearEnrollment?.currentMidYearEnrollment?.processing_messages?.errors,
	);

	if (!errors || errors.length < 1) return null;

	return (
		<ContentSpacer>
			<Banner
				banner={{
					type: 'error',
					label: <p><strong>{errors?.map(e => e).join(', ')}</strong></p>,
				}}
			/>
		</ContentSpacer>
	);
}